import {
  getAllToursService,
  updateTourStatusService
} from '../services/appTourService'

const set_createPaymentLinkDrawerStatus = 'set_createPaymentLinkDrawerStatus'
const set_cardsScreen = 'set_cardsScreen'
const set_currentVirtualCardCreationStep = 'set_currentVirtualCardCreationStep'
const set_startCardsTourTwo = 'set_startCardsTourTwo'
const set_startCardsTourThree = 'set_startCardsTourThree'
const set_currentSettingsTourIndex = 'set_currentSettingsTourIndex'
const set_settingsTourIsActive = 'set_settingsTourIsActive'
const set_currentPaymentLinkTourIndex = 'set_currentPaymentLinkTourIndex'
const set_paymentLinkTourIsActive = 'set_paymentLinkTourIsActive'
const set_allTours = 'set_allTours'

const getDefaultState = () => {
  return {
    paymentLinkTourIsActive: false,
    startBulkPayoutTourTwo: false,
    currentPaymentLinkTourIndex: 1,
    cardsScreen: 'add-new-card',
    currentVirtualCardStep: 1,
    startCardsTourTwo: false,
    startCardsTourThree: false,
    currentSettingsTourIndex: 1,
    settingsTourIsActive: false,
    allTours: {}
  }
}
const state = getDefaultState()

const mutations = {
  [set_currentPaymentLinkTourIndex] (state, data) {
    state.currentPaymentLinkTourIndex = data
  },
  [set_paymentLinkTourIsActive] (state, data) {
    state.paymentLinkTourIsActive = data
  },
  [set_createPaymentLinkDrawerStatus] (state, data) {
    state.startBulkPayoutTourTwo = data
  },
  [set_cardsScreen] (state, data) {
    state.cardsScreen = data
  },
  [set_currentVirtualCardCreationStep] (state, data) {
    state.currentVirtualCardStep = data
  },
  [set_startCardsTourTwo] (state, data) {
    state.startCardsTourTwo = data
  },
  [set_startCardsTourThree] (state, data) {
    state.startCardsTourThree = data
  },
  [set_currentSettingsTourIndex] (state, data) {
    state.currentSettingsTourIndex = data
  },
  [set_settingsTourIsActive] (state, data) {
    state.settingsTourIsActive = data
  },
  [set_allTours] (state, data) {
    state.allTours = data
  }
}

const actions = {
  updateCreatePaymentLinkDrawerStatus ({ commit }, data) {
    commit('set_createPaymentLinkDrawerStatus', data)
  },
  updatePaymentLinkTourStatus ({ commit }, data) {
    commit('set_paymentLinkTourIsActive', data)
  },
  updateCurrentPaymentLinkTourIndex ({ commit }, data) {
    commit('set_currentPaymentLinkTourIndex', data)
  },
  updateCardsScreen ({ commit }, data) {
    commit('set_cardsScreen', data)
  },
  updateCurrentVirtualCardCreationStep ({ commit }, data) {
    commit('set_currentVirtualCardCreationStep', data)
  },
  startCardsTourTwo ({ commit }, data) {
    commit('set_startCardsTourTwo', data)
  },
  startCardsTourThree ({ commit }, data) {
    commit('set_startCardsTourThree', data)
  },
  updateCurrentSettingsTourIndex ({ commit }, data) {
    commit('set_currentSettingsTourIndex', data)
  },
  updateSettingsTourStatus ({ commit }, data) {
    commit('set_settingsTourIsActive', data)
  },
  fetchAllTours ({ commit }) {
    return getAllToursService().then((response) => {
      commit('set_allTours', response.data.data)
    })
  },
  updateTourStatus ({ commit }, payload) {
    return updateTourStatusService(payload).then((response) => {
      commit('set_allTours', response.data.data)
    })
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
